// extracted by mini-css-extract-plugin
export default {"Emojify":"bbz_a bia_g"};